// extracted by mini-css-extract-plugin
export default {"root":"action-icon_root__OtROj"};